import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

// Fix marker icon issue
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

const Map = () => {
  const position = [11.611860, 75.573837]; // Vidyalaya's latitude and longitude

  return (
    <MapContainer center={position} zoom={13} style={{ height: '600px', width: '100%' }}> {/* Increased height to 600px */}
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        
      />
      <Marker position={position}>
        <Popup>
          Vidyalaya Institute
        </Popup>
      </Marker>
    </MapContainer>
  );
};

export default Map;
